import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { ApontamentoProducao } from '../../types/producao';
import { apontamentosProducaoService } from '../../services';

const columns: ResourceColumn<ApontamentoProducao>[] = [
  { header: "Ordem", accessor: "ordem_codigo" },
  { header: "Operador", accessor: "operador" },
  { header: "Máquina", accessor: "maquina_nome" },
  { header: "Início", accessor: "data_inicio" },
  { header: "Produção/Refugo", render: (item) => item.quantidade_produzida + "/" + item.quantidade_refugada }
];

export const ApontamentosProducaoListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="Apontamentos de produção"
    description="Execuções registradas por ordem."
    columns={columns}
    service={apontamentosProducaoService}
    createPath="/admin/producao/apontamentos-producao/novo"
      onEdit={(item) => item.id && navigate("/admin/producao/apontamentos-producao/editar", { state: { record: item } })}
  />
  );
};